/**
 * Utility functions for categorizing and filtering photos
 */

/**
 * Group photos by category
 * @param {Array} photoTemplate - Array of photo template objects
 * @returns {Object} Object with photos grouped by category
 */
export const groupPhotosByCategory = (photoTemplate) => {
    return {
        exterior: photoTemplate.filter(p => p.category === 'exterior'),
        interior: photoTemplate.filter(p => p.category === 'interior'),
        detail: photoTemplate.filter(p => p.category === 'detail')
    };
};

/**
 * Count existing photos by category
 * @param {Array} existingPhotos - Array of existing photo objects
 * @returns {Object} Object with counts per category
 */
export const countPhotosByCategory = (existingPhotos) => {
    return {
        exterior: existingPhotos.filter(p => p.category === 'exterior').length,
        interior: existingPhotos.filter(p => p.category === 'interior').length,
        detail: existingPhotos.filter(p => p.category === 'detail').length
    };
};
